import React, { useEffect, useState, useLayoutEffect } from 'react'
import Carousel from './Carousel'
import NewsMobile from './NewsMobile'
import PropTypes from 'prop-types'
import { motion, AnimatePresence } from 'framer-motion'
import './styles.scss'

export default function NewsCarousel({
  data = {
    title: 'ALL IN WEDDINGS BLOG',
    subtitle: 'OUR BLOG',
    kind_of_news: 'Blog',
  },
}) {
  const [posts, setPosts] = useState([])
  const [size, setSize] = useState(null)
  const [error, setError] = useState(null)

  useLayoutEffect(() => {
    function updateSize() {
      setSize(window.innerWidth)
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  useEffect(() => {
    const fetchPosts = async () => {
      const Link =
        data.kind_of_news === 'Blog'
          ? 'https://blog.allinweddings.com/wp-json/wp/v2/posts?per_page=10&_embed'
          : '/wp-json/wp/v2/release?per_page=10&_embed'
      try {
        const response = await fetch(Link)
        const dataFetch = await response.json()

        const formattedPosts = dataFetch?.map((post) => {
          return {
            id: post.id,
            title: post.title.rendered,
            excerpt: data.kind_of_news === 'Blog' ? post.excerpt.rendered : post.content.rendered,
            url: post.link,
            featuredImage: post._embedded?.['wp:featuredmedia']
              ? post._embedded?.['wp:featuredmedia'][0]?.source_url
              : null,
          }
        })

        setPosts(formattedPosts)
      } catch (error) {
        setError('Error fetching posts')
      }
    }

    fetchPosts()
  }, [data])

  return (
    <section className="news-carousel">
      <div className="news-carousel__header">
        <AnimatePresence>
          <motion.h3
            key="subtitle"
            transition={{
              duration: 0.7,
              delay: 0.4,
            }}
            viewport={{
              once: true,
            }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            exit={{ opacity: 1 }}
            className="news-carousel__subtitle"
          >
            {data.subtitle}
          </motion.h3>
          <motion.h2
            key="title"
            transition={{
              duration: 0.7,
              delay: 0.4,
            }}
            viewport={{
              once: true,
            }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            exit={{ opacity: 1 }}
            className="news-carousel__title"
          >
            {data.title}
          </motion.h2>
        </AnimatePresence>
      </div>

      {error ? (
        <div className="main-container">
          <h4 className="col-span-12 text-xl">{error}</h4>
        </div>
      ) : size >= 1024 ? (
        <Carousel kind_of_news={data.kind_of_news} posts={posts} />
      ) : (
        <NewsMobile posts={posts} kind_of_news={data.kind_of_news} />
      )}
    </section>
  )
}

NewsCarousel.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    kind_of_news: PropTypes.string,
  }),
}
